export default __webpack_public_path__ + "static/media/sketch03.a5338dfe.png";